<template>
    <div>
        <Header>

            <div class="buttons-right"  v-if="page">

                <span v-if="!allChangesSaved(page)" class="change-notice change-notice--unsaved"><span v-t="'Unsaved Changes'"></span> <i class="material-icons">error_outline</i></span>
                <span v-if="allChangesSaved(page)" class="change-notice"><span  v-t="'All Changes Saved'"></span></span>
                <a class="button--delete" @click="deletePage()" v-if="page.slug!='home'" v-t="'Delete Page?'"></a>
                <a class="button button--secondary" target="_blank" onclick="window.open(this.href, 'jp-dashboard'); return false" :href="portfolio.get_absolute_url+page.get_absolute_url" v-if="page.slug!='home'" v-t="'View Page'"></a>
                <a class="button button--secondary" target="_blank" onclick="window.open(this.href, 'jp-dashboard'); return false" :href="portfolio.get_absolute_url" v-if="page.slug=='home'" v-t="'View Page'"></a>
                <save-button name="Page" :status="saving" @save="save()"></save-button>
            </div>

        </Header>

        <div class="page">

            <div class="alert" v-if="page&&page.slug!='home'&&portfolio.restricted===true">
                <i class="material-icons">warning</i>
                <p>
                    <span v-t="'Page not currently displaying due to the limits on the free plan.'"></span> <router-link :to="{name: 'account'}"><span v-t="'Upgrade to remove limits'"></span> &rarr;</router-link>
                </p>
            </div>
            <div class="right-col">
                <div class="block" v-if="!page">
                    <div class="loading-gif" >
                        <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                    </div>
                </div>


                <div class="block" v-if="page&&page.page_type!='link'">
                    <h3 class="block__heading" v-t="'Page Details'"></h3>

                    <div class="left-1">
                        <field :errors="errors" label="Page Name" name="name">
                            <input type="text" v-model="page.name">
                        </field>
                        <div class="field field--file" v-if="page.page_type!='link'">
                            <field :errors="errors" v-if="page.page_type!='link'" label="SEO Description" name="seo_description">
                                <AutosizeTextarea v-model="page.seo_description"></AutosizeTextarea>
                                <span class="help_text">An optional description used by search engines. Should describe the page.</span>
                            </field>
                        </div>

                    </div>

                    <div class="hr"></div>

                    <div class="left-1">
                        <div class="field field-width">
                            <label v-t="'Social Sharing Image'"></label>


                            <div class="field field--file">

                                <image-picker @remove="page.image=null" :model="page" @close="page.image=$event"></image-picker>

                            </div>
                            <span class="help_text">An optional image the is used when sharing on social media. Max 1200x627px</span>
                        </div>
                    </div>

                    <div class="hr"></div>

                    <div class="left-1">
                        <field :errors="errors" v-if="!page.home_page" class="field field-switch">
                            <label class="switch">
                                <input v-model="page.published" type="checkbox">
                                <div class="slider round"></div>
                            </label>
                            <span class="label" v-t="'Display on portfolio?'"></span>
                        </field>
                        <field :errors="errors" v-if="!page.home_page" class="field field-switch">
                            <label class="switch">
                                <input v-model="page.show_in_nav" type="checkbox">
                                <div class="slider round"></div>
                            </label>
                            <span class="label" v-t="'Show in the navigation?'"></span>
                        </field>
                        <field :errors="errors" v-if="page.slug!=='home'&&page.page_type!='link'" class="field field-switch">
                            <label class="switch">
                                <input v-model="page.home_page" type="checkbox">
                                <div class="slider round"></div>
                            </label>
                            <span class="label" v-t="'Set page as home page?'"></span>
                        </field>

                        <a @click="openPrivacySettings()" class="page-privacy-link"><i class="material-icons">lock</i> Page Privacy Settings</a>

                    </div>
                </div>
            </div>
            <div class="left-col" v-if="!page">
                <div class="block">
                    <div class="loading-gif" >
                        <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                    </div>
                </div>
            </div>

            <div class="left-col" v-if="page&&page.page_type=='link'">
                <div class="block">
                    <field :errors="errors" label="Redirect URL" name="url">
                        <input type="text" v-model="page.url">
                    </field>
                </div>
            </div>
            <div class="left-col" v-if="page&&page.page_type!='link'">

                <div class="blocks__add">
                    <div class="floating" @click="openBlocks('top')">
                        <i class="material-icons">add</i> <span v-t="'Add a Content Block'"></span>
                    </div>
                </div>

                <div class="loadiv-icon" v-if="!page"><i class="material-icons">sync</i> <span v-t="'Loading...'"></span></div>

                <div class="block" v-if="page.home_page">
                    <span v-t="'You can edit your profile picture, portfolio title, social links and bio on the'"></span>&nbsp;<router-link :to="{name: 'settings'}">settings page</router-link>.
                </div>

                <span v-bind:key="index" v-for="(block, index) in page.blocks">

                 <div class="block" :class="{'block--articles': block.definition.type=='articles', 'block--closed': block.closed, 'block--full': block.definition.fields.length==1&&block.definition.fields[0].type=='richtext'}">
                    <h3 class="block__heading block__heading--page" @click="toggle(block)"><i class="material-icons">arrow_drop_down</i> <span class="title">{{$t(block.definition.name)}} {{$t('Block') }}</span>
                        <span class="right">
                            <i class="material-icons material-icons--delete" alt="Remove this block" title="Remove this block" @click="deleteBlock(block)">delete</i>
                            <i class="material-icons material-icons--arrow" alt="Move Block Up" title="Move Block Up" v-if="index!=0" @click="moveBlockUp(block)">arrow_upward</i>
                            <i class="material-icons material-icons--arrow" alt="Move Block Down" title="Move Block Down" v-if="index!=page.blocks.length-1" @click="moveBlockDown(block)">arrow_downward</i>
                        </span>
                    </h3>

                    <div class="block__tabs" v-if="block.definition.show_design">
                      <a class="tab" :class="{'active': block.tab!='design'}" @click="tab(block, 'content')"><i class="material-icons">insert_drive_file</i> Block Content</a>
                      <a class="tab" :class="{'active': block.tab=='design'}" @click="tab(block, 'design')"><i class="material-icons">format_color_fill</i> Block Design</a>
                    </div>


                        <span v-if="(!field.design&&block.tab!='design')||(field.design&&block.tab=='design')" :class="{'field--top-hr': field.type=='list'}" v-bind:key="subindex" v-for="(field, subindex) in block.definition.fields">

                         <div class="field field-width" style="clear:both;" v-if="field.type=='richtext'">
                            <label v-if="block.definition.fields.length!=1">{{$t(field.name)}}</label>

                            <Redactor v-model="block.fields[field.handle].value" :config="{buttons: ['html', 'format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'image', 'file', 'link', 'horizontalrule'],  fileUpload: 'https://api.journoportfolio.com/redactor-upload/', fileManagerJson: 'https://api.journoportfolio.com/redactor-files/', linkNewTab: true, linkTitle: true,  imageUpload: 'https://api.journoportfolio.com/redactor-upload/', imageManagerJson: 'https://api.journoportfolio.com/redactor-images/', imageResizable: true, imagePosition: true, plugins: ['table', 'video', 'fontsize', 'alignment', 'fontcolor', 'imagemanager', 'filemanager'], replaceDivs: false }" />
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='textarea'">
                            <label>{{$t(field.name)}}</label>
                            <textarea v-model="block.fields[field.handle].value"></textarea>
                            <span class="help_text">{{field.help_text}}</span>
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='text'">

                            <field :errors="errors" :label="field.name" name="name">
                                <input type="text" v-model="block.fields[field.handle].value">
                                <div class="help_text">{{field.help_text}}</div>
                            </field>
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='url'">
                            <u-r-l-field :errors="errors" :label="field.name" v-model="block.fields[field.handle].value" :help="field.help_text" />
                        </div>
                        <div class="field" v-if="field.type=='list'">

                            <span v-bind:key="subsubindex" v-for="(sub_data_field, subsubindex) in block.fields[field.handle]" class="sub-field"  >

                                <div v-if="sub_data_field">
                                    <div class="sub-field__btns">
                                        <span><i class="material-icons">{{block.definition.icon}}</i> {{field.list_name}} {{subsubindex+1}}</span>

                                        <div class="icons">
                                            <i class="material-icons material-icons--delete" @click="deleteListField(block, field.handle, subsubindex)">delete</i>
                                            <i class="material-icons material-icons--arrow" v-if="subsubindex!=0" @click="moveListFieldUp(block, field.handle, subsubindex)">arrow_upward</i>
                                            <i class="material-icons material-icons--arrow" v-if="subsubindex!=block.fields[field.handle].length-1" @click="moveListFieldDown(block, field.handle, subsubindex)">arrow_downward</i>
                                        </div>
                                    </div>

                                    <span v-bind:key="sub_field.id" v-for="sub_field in field.fields" >

                                        <div class="field field-width" style="clear:both;" v-if="sub_field.type=='textarea'">
                                            <label>{{$t(sub_field.name)}}</label>
                                            <textarea v-model="sub_field.value"></textarea>
                                            <span class="help_text">{{sub_field.help_text}}</span>
                                        </div>
                                        <div class="field field-width" style="clear:both;" v-if="sub_field.type=='text'">

                                            <field :errors="errors" :label="sub_field.name" name="name">
                                                <input type="text" v-model="block.fields[field.handle][subsubindex].fields[sub_field.handle].value">
                                                <div class="help_text">{{sub_field.help_text}}</div>
                                            </field>
                                        </div>
                                        <div class="field field-width" style="clear:both;" v-if="sub_field.type=='url'">

                                            <u-r-l-field :errors="errors" :label="sub_field.name" v-model="block.fields[field.handle][subsubindex].fields[sub_field.handle].value" :help="sub_field.help_text" />
                                        </div>

                                        <div class="field field-width" style="clear:both;" v-if="sub_field.type=='image'">
                                            <label>{{$t(sub_field.name)}}</label>
                                            <div class="field field--file" >
                                                <image-picker :cachebuster="cachebuster" @remove="setImageNull(block, block.fields[field.handle][subsubindex].fields[sub_field.handle], null)"
                                                :model="block.fields[field.handle][subsubindex].fields[sub_field.handle]" @close="setImage(block, block.fields[field.handle][subsubindex].fields[sub_field.handle], $event)"></image-picker>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </span>

                            <div class="blocks__add__list">
                                <div class="button" @click="addListItem(block, field.handle)">
                                    <i class="material-icons nospin">add</i> Add
                                    <span v-if="['A', 'I', 'E', 'O', 'U'].indexOf(field.list_name[0])!==-1">an</span>
                                    <span v-if="['A', 'I', 'E', 'O', 'U'].indexOf(field.list_name[0])===-1">a</span> {{field.list_name}}
                                </div>
                            </div>
                        </div>

                        <field :errors="errors" class="field field-width field-checkbox" style="clear:both;" v-if="field.type=='checkbox'">
                            <label class="label--checkbox">
                                <input type="checkbox" class="checkbox" v-model="block.fields[field.handle].value" >
                                {{$t(field.name)}}
                            </label>
                        </field>

                        <div class="field field-width" style="clear:both;" v-if="field.type=='select'">

                            <field :errors="errors" :label="field.name" name="name">
                                <select v-model="block.fields[field.handle].value">
                                    <option v-bind:key="option" v-for="option in field.options" :value="option">{{option}}</option>
                                </select>
                                <div class="help_text">{{field.help_text}}</div>
                            </field>
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='article'">
                            <article-field :errors="errors" :articles="articles" :label="field.name" v-model="block.fields[field.handle].article"/>
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='file'">

                            <label>{{$t(field.name)}}</label>
                            <div class="field field--file" >

                                <file-picker  @remove="block.fields[field.handle].file=null"  :model="block.fields[field.handle].file" @changed="block.fields[field.handle].file=$event" title="Upload Document"></file-picker>

                            </div>
                        </div>
                        <div class="field field-width" style="clear:both;" v-if="field.type=='image'">

                            <label>{{$t(field.name)}}</label>
                            <div class="field field--file" >

                                <image-picker :cachebuster="cachebuster" @remove="setImageNull(block, block.fields[field.handle], null)" :model="block.fields[field.handle]" @close="setImage(block, block.fields[field.handle], $event)"></image-picker>

                            </div>
                        </div>
                    </span>

                    <span v-if="block.definition.type=='articles'&&block.tab!='design'" style="display:block;margin: 0 -30px;">

                <div class="field field--articles" style="clear:both;padding: 0 30px;">
                    <label v-t="'Order by'"></label>
                    <select v-model="block.article_order" @change="updateOrdering(block)">
                        <option value="newest" v-t="'Latest first'"></option>
                        <option value="oldest" v-t="'Oldest first'"></option>
                        <option value="alphabetically" v-t="'Alphabetically'"></option>
                        <option value="custom" v-t="'Custom ordering'"></option>
                    </select>
                </div>

                <label class="label--checkbox label--checkbox-article-block">
                    <input type="checkbox" class="checkbox" true-value="auto" false-value="manual" v-model="block.article_type"> <span v-t="'Automatically add articles'"></span>
                </label>

                <div class="field--auto-parent" :class="{'block-height-padded': block.article_type!='auto'}" v-if="block.article_type=='auto'">

                    <div class="field--auto">
                        <field :errors="errors" label="Automatically add articles with tags..." name="order">
                            <input type="text" @keyup="tagSearch(block)" v-model="block.search_tag_text" placeholder="Search your tags...">
                            <div class="live-search" v-if="block.search_tag_results&&block.search_tag_results.length">
                                <div class="live-search__contents">
                                    <div class="result" @click="clickTagResult(block, result)" v-bind:key="result.tag" v-for="result in block.search_tag_results">
                                        {{result.tag}}
                                    </div>
                                </div>
                            </div>
                        </field>
                        <div class="publication-tags" v-if="block.article_type=='auto'">

                            <span class="article-tag" v-bind:key="tag.tag" v-for="tag in block.tag_set">
                                {{tag.tag}}
                                <span class="article-tag__remove" @click="removeTag(block, tag)"><i class="material-icons">close</i></span>
                            </span>

                        </div>
                    </div>
                    <div class="field field--auto-type">
                        <label v-t="'and that have...'"></label>
                        <select @change="updateAutoArticles(block)" class="font-picker font-picker-heading" v-model="block.tag_query_type">
                            <option value="OR" v-t="'ANY of these tags'"></option>
                            <option value="AND" v-t="'ALL of these tags'"></option>
                            <option value="NONE" v-t="'NONE of these tags'"></option>
                        </select>
                    </div>
                </div>

                <table v-if="block.article_order=='custom'&&block.article_type!='auto'" class="editor-table editor-table--full" style="border-top: 1px solid #ddd;">
                    <tbody>
                        <tr class="add-tr">
                            <td colspan="3" @click="selectArticle(block)"><i class="material-icons">add</i> <span v-t="'Add Articles'"></span></td>
                        </tr>
                    </tbody>
                </table>
                <table class="editor-table editor-table--full" style="border-top: 1px solid #ddd;">
                    <tbody v-if="block.article_order!='custom'">
                        <tr v-if="block.article_type!='auto'" class="add-tr">
                            <td colspan="3" @click="selectArticle(block)"><i class="material-icons">add</i> <span v-t="'Add Articles'"></span></td>
                        </tr>
                        <tr v-bind:key="article.id" v-for="article in block.article_set" :class="{'checked': selection.indexOf(article.id) > -1}" class="item">
                            <td width="100%">
                                <div class="img" v-if="article.image" :style="{'background-image': 'url('+article.image.image+')'}"></div>
                                <div class="img" v-if="!article.image" ></div>
                                <div class="img-text">
                                    <router-link :to="{name: 'article', params: {id: article.id}}" class="ellipsis">{{article.title}}</router-link>
                                    <span class="ellipsis grey">{{article.publication_name}} &bullet; {{article.published_date}}</span>
                                </div>
                            </td>
                            <td width="50px">
                                <i v-if="block.article_type!='auto'" @click="removeArticle(block, article)" class="material-icons">close</i>
                            </td>
                        </tr>
                    </tbody>
                    <draggable v-if="block.article_order=='custom'" :element="'tbody'" v-model="block.article_set">
                        <tr v-bind:key="article.id" v-for="article in block.article_set" :class="{'checked': selection.indexOf(article.id) > -1}" class="item">
                            <td width="50px" ><i class="material-icons">reorder</i>
                            </td>
                            <td width="100%">
                                <div class="img" v-if="article.image" :style="{'background-image': 'url('+article.image.image+')'}"></div>
                                <div class="img" v-if="!article.image" ></div>
                                <div class="img-text">
                                    <router-link :to="{name: 'article', params: {id: article.id}}" class="ellipsis">{{article.title}}</router-link>
                                    <span class="ellipsis grey">{{article.publication_name}} &bullet; {{article.published_date}}</span>
                                </div>
                            </td>
                            <td width="50px">
                                <i v-if="block.article_type!='auto'" @click="removeArticle(block, article)" class="material-icons">close</i>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </span>
            </div>
        </span>
        <div class="blocks__add">
            <div class="floating" @click="openBlocks('bottom')" v-if="page.blocks.length>0">
                <i class="material-icons nospin">add</i> <span v-t="'Add a Content Block'"></span>
            </div>
        </div>
    </div>
</div>

<modal-page-delete v-if="page" :page="page" :open="modalDeleteOpen" @close="modalDeleteOpen=false"></modal-page-delete>

<modal-page-privacy v-if="page" :page="page" :open="modalPrivacyOpen" @close="modalPrivacyOpen=false"></modal-page-privacy>

<modal-page-block-add :open="modalBlocksOpen" @close="modalBlocksClose"></modal-page-block-add>
<modal-page-article-add :articleIDs="modalAddArticleArticleIDs" :open="modalAddArticleOpen" @close="modalAddArticleClose"></modal-page-article-add>
    <modal-unsaved-changes :open="modalUnsavedChangesOpen" @leave="leavePage" @close="modalUnsavedChangesOpen=false"></modal-unsaved-changes>
</div>
</template>

<script>
    import Vue from 'vue'
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import URLField from '@/components/fields/URLField.vue'
    import ArticleField from '@/components/fields/ArticleField.vue'
    import AutosizeTextarea from '@/components/AutosizeTextarea.vue'
    import ImagePicker from  '@/components/ImagePicker.vue'
    import FilePicker from  '@/components/FilePicker.vue'
    import SaveButton from '@/components/SaveButton.vue'
    import Redactor from '@/components/Redactor.vue'
    import ModalPageDelete from '@/components/modals/ModalPageDelete.vue'
    import ModalPagePrivacy from '@/components/modals/ModalPagePrivacy.vue'
    import ModalPageBlockAdd from '@/components/modals/ModalPageBlockAdd.vue'
    import ModalPageArticleAdd from '@/components/modals/ModalPageArticleAdd.vue'
    import ModalUnsavedChanges from '@/components/modals/ModalUnsavedChanges.vue'
    import draggable from 'vuedraggable'

    export default {
        components: {
            Header,
            Field,
            URLField,
            ArticleField,
            AutosizeTextarea,
            ImagePicker,
            FilePicker,
            SaveButton,
            Redactor,
            ModalPageDelete,
            ModalPagePrivacy,
            ModalPageBlockAdd,
            ModalPageArticleAdd,
            ModalUnsavedChanges,
            draggable
        },

        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                errors: {},
                saving: false,
                definition: null,
                cachebuster: 1,
                page: null,
                tags: [],
                modalDeleteOpen: false,
                modalAddArticleOpen: false,
                modalAddArticleBlock: null,
                modalAddArticleArticleIDs: [],
                modalPrivacyOpen: false,
                modalBlocksOpen: false,
                modalUnsavedChangesOpen: false,
                next: null,
                articles: [],
                selection: [],
                position: 'top'
            }
        },
        methods: {
            leavePage () {
                this.modalUnsavedChangesOpen = false;
                this.next()
            },
            toggle (section){
                section.closed = !section.closed
                this.$forceUpdate()
            },
            tab (section, tab){
                section.tab = tab
                this.$forceUpdate()
            },
            save () {
                // cache section.closed
                var sections_closed = []
                var tabs = []

                this.saving = true
                this.$http.put('/pages/'+this.page.id+'/', this.page).then(data => {

                    for(var k=0;k<this.page.blocks.length; k++){
                        sections_closed.push(this.page.blocks[k].closed);
                        tabs.push(this.page.blocks[k].tab);
                    }

                    this.page = data.data
                    this.saving = false
                    for(var i=0; i<this.page.blocks.length; i++){
                        for(var j=0; j<this.definition.blocks.length; j++){
                            if(this.definition.blocks[j].type == this.page.blocks[i].type){
                                this.page.blocks[i].definition = this.definition.blocks[j]
                            }
                        }
                    }

                    for(var l=0;l<this.page.blocks.length; l++){
                        this.page.blocks[l].closed = sections_closed[l];
                        this.page.blocks[l].tab = tabs[l];
                    }

                    this.past_page = this.stringifyPage(this.page);
                }).catch(errors => {
                    this.saving = null
                    if(errors.response && errors.response.data){
                      this.errors = errors.response.data
                    }
                })
            },
            stringifyPage (page){
              return JSON.stringify(page).split('"tab":"content"').join('').split('"tab":"design"').join('').split('"closed":true').join('').split('"closed":false').join('')
            },
            removeArticle (block, article){
                block.article_set.splice( block.article_set.indexOf(article), 1);
                block.articles.splice( block.articles.indexOf(article.id), 1);
                if(block.id){
                    this.$http.delete('/pages/'+this.page.id+'/blocks/'+block.id+'/articles/'+article.id+'/').then(data => {
                    }).catch(errors => {
                      if(errors.response && errors.response.data){
                        this.errors = errors.response.data
                      }
                    })
                }
            },
            selectArticle (block) {
                this.modalAddArticleBlock = block
                this.modalAddArticleArticleIDs = block.articles.join(',')
                this.modalAddArticleOpen = true
            },
            setImageNull (block, field, image){
                Vue.set(field, 'image', null)
                this.$forceUpdate()
                this.cachebuster = this.cachebuster + 1
            },
            setImage (block, field, image){
                Vue.set(field, 'image', Object.assign({}, image))
                this.$forceUpdate()
                this.cachebuster = this.cachebuster + 1
            },
            modalAddArticleClose ( value ) {
                this.modalAddArticleOpen = false
                if (value ){
                    if (value === 'new'){
                        this.addPageArticle()
                    }else{
                        this.clickResult(this.modalAddArticleBlock, value)
                    }
                }
            },
            deleteBlock (block) {
                this.page.blocks.splice(this.page.blocks.indexOf(block), 1);
            },
            addPageArticle (){
                this.results = [];
                this.$parent.addArticle();
            },
            moveBlockUp (block) {
                var index = this.page.blocks.indexOf(block);
                if(index > 0){
                    this.page.blocks.splice(index, 1);
                    this.page.blocks.splice(index-1, 0, block);
                }
            this.$forceUpdate()
                var a = Object.assign([], this.page.blocks)
                this.page.blocks = []
            this.$forceUpdate()
                this.page.blocks = a
                this.$forceUpdate()
            },
            clickResult (block, articles) {
                for( var i=0; i<articles.length; i++){
                    var article = articles[i]
                    block.article_set.unshift(article);
                    block.articles.push(article.id);
                    if(block.id){
                        this.$http.post('/pages/'+this.page.id+'/blocks/'+block.id+'/articles/', {id: article.id}).then(data => {
                        }).catch(errors => {
                          if(errors.response && errors.response.data){
                            this.errors = errors.response.data
                          }
                        })
                    }
                }
            },
            tagSearch ( block ){
                if(block.search_tag_text && block.search_tag_text.length){
                    var term = block.search_tag_text.toLowerCase();
                    block.search_tag_results = [];
                    for (var i=0; i<this.tags.length; i++){
                        var tag = this.tags[i]
                        if(tag.tag.toLowerCase().indexOf(term) !== -1){
                            if(block.tags.indexOf(tag.id) === -1){
                               block.search_tag_results.push(tag);
                           }
                       }
                   }
               }
           },
           removeTag ( block, tag){
            block.tags.splice( block.tags.indexOf(tag.id), 1)
            block.tag_set.splice( block.tags.indexOf(tag), 1)
            if(block.article_type === 'auto'){
                this.updateAutoArticles(block)
            }
        },
        updateOrdering (block) {
            if(block.article_order === 'newest'){
                block.article_set = block.article_set.sort(this.sort_newest).reverse();
            }else if(block.article_order === 'alphabetically'){
                block.article_set = block.article_set.sort(this.sort_alphabetically);
            }else if(block.article_order === 'oldest'){
                block.article_set = block.article_set.sort(this.sort_newest);
            }
        },
        updateAutoArticles (block) {
            block.article_set = [];

            this.$http.get('/articles/?tags='+block.tags.join(',')+'&tag_query_type='+block.tag_query_type).then(data => {
                block.article_set = data.data;
                if(block.article_order === 'newest'){
                    block.article_set = block.article_set.sort(this.sort_newest).reverse();
                }else if(block.article_order === 'alphabetically'){
                    block.article_set = block.article_set.sort(this.sort_alphabetically);
                }else if(block.article_order === 'oldest'){
                    block.article_set = block.article_set.sort(this.sort_newest);
                }
            })
        },
        sort_alphabetically (a,b) {
            if(a.title < b.title) { return -1; }
            if(a.title > b.title) { return 1; }
            return 0;
        },
        sort_newest (a,b) {
            var a_from = a.published_date.split("-");
            var a_date = new Date(parseInt(a_from[0], 10), parseInt(a_from[1], 10) - 1, a_from[2]);
            var b_from = b.published_date.split("-");
            var b_date = new Date(parseInt(b_from[0], 10), parseInt(b_from[1], 10) - 1, b_from[2]);
            if (a_date < b_date){
                return -1;
            }else if (a_date > b_date){
                return 1;
            }else{
                return 0;
            }
        },
        clickTagResult (block, tag) {
            block.tag_set.push(tag)
            block.tags.push(tag.id)
            block.search_tag_results = []
            block.search_tag_text = ''
            if(block.article_type === 'auto'){
                this.updateAutoArticles(block)
            }
        },
        moveBlockDown (block){
            var index = this.page.blocks.indexOf(block);
            if(index < this.page.blocks.length){
                this.page.blocks.splice(index, 1);
                this.page.blocks.splice(index+1, 0, block);
            }
            this.$forceUpdate()
            var a = Object.assign([], this.page.blocks)
            this.page.blocks = []
            this.$forceUpdate()
            this.page.blocks = a
            this.$forceUpdate()
        },
        modalBlocksClose (result) {
            this.modalBlocksOpen = false
            if (result){
                var b = {tab: 'content', tags: [], tag_set: [], type: result.type, articles: [], article_set: [], tag_query_type: 'OR', article_order: 'newest', article_type: 'manual', fields: {}};
                var def = this.blockDefinition(result);
                b.definition = def

                for (var i=0; i<def.fields.length; i++){
                    var field = def.fields[i]
                    if(field.type === 'list'){
                        var first = {order: 1, fields: {}};

                        for (var j=0; j<field.fields.length; j++){
                            var sub_field = field.fields[j]
                            first.fields[sub_field.handle] = {image: null, value: ''};
                        }
                        b.fields[field.handle] = [first, ];
                    }else{
                        b.fields[field.handle] = {};
                        if (field.default){
                            b.fields[field.handle].value = field.default
                        }
                    }
                }
                if('show_filter_bar' in b.fields){
                    b.fields.show_filter_bar.value = true
                }
                if(this.position === 'top'){
                    this.page.blocks.unshift(b);
                }else{
                    this.page.blocks.push(b);
                }
            }
        },
        blockDefinition (block){
            var ret = {};
            for (var i=0; i<this.blocks.length; i++){
                var block_def = this.blocks[i]
                if(block_def.type === block.type){
                    ret = block_def;
                }
            }
            return ret;
        },
        allChangesSaved (page){
            if(!page){
                return false;
            }
            if (this.past_page === this.stringifyPage(this.page)){
                return true
            }
            return false;
        },
        deleteListField (block, handle, index){
            block.fields[handle].splice(index, 1);
            block.fields[handle] = JSON.parse(JSON.stringify(block.fields[handle]))
        },
        moveListFieldUp (block, handle, index){
            var backup = JSON.parse(JSON.stringify(block.fields[handle][index]))
            if(index > 0){
                block.fields[handle].splice(index, 1);
                block.fields[handle].splice(index-1, 0, backup);
            }
            block.fields = JSON.parse(JSON.stringify(block.fields))
        },
        moveListFieldDown (block, handle, index){
            var backup = JSON.parse(JSON.stringify(block.fields[handle][index]))
            if(index < block.fields[handle].length){
                block.fields[handle].splice(index, 1);
                block.fields[handle].splice(index+1, 0, backup);
            }
            block.fields = JSON.parse(JSON.stringify(block.fields))
        },
        addListItem (block, field_handle){
            var length = 1;
            if(block.fields[field_handle] && block.fields[field_handle].length){
                length = block.fields[field_handle].length + 1;
            }
            var first = {order: length, fields: {}};
            var def = this.blockDefinition(block);
            for (var i=0; i<def.fields.length; i++){
                var field = def.fields[i]
                if(field.handle === field_handle){
                    for (var j=0; j<field.fields.length; j++){
                        var sub_field = field.fields[j]
                        first.fields[sub_field.handle] = {value: ''};
                    }
                }
            }
            if (!block.fields[field_handle]){
                block.fields[field_handle] = []
            }
            block.fields[field_handle].push(first);
            this.$forceUpdate()
        },
        deletePage () {
            this.modalDeleteOpen = true
        },
        openPrivacySettings  () {
            this.modalPrivacyOpen = true
        },
        openBlocks (top) {
            this.position = top
            this.modalBlocksOpen = true
        },
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        },
        portfolio () {
            return this.$store.getters['portfolio/portfolio']
        },
    },
    mounted () {
        this.$store.dispatch('auth/load')
        this.$http.all([
            this.$http.get('/pages/'+this.$route.params.id+'/'),
            this.$http.get('/portfolio/theme/definition/'),
            this.$http.get('/tags/'),
            ])
        .then(this.$http.spread((page, definition, tags) => {
            this.page = page.data
            this.definition = definition.data
            this.blocks = definition.data.blocks
            this.tags = tags.data
            for(var i=0; i<this.page.blocks.length; i++){
                this.page.blocks[i].closed = false;
                if(this.page.blocks.length > 3){
                    this.page.blocks[i].closed = true;
                }
                this.page.blocks[i].tab = 'content';
                for(var j=0; j<this.definition.blocks.length; j++){
                    if(this.definition.blocks[j].type == this.page.blocks[i].type){
                        this.page.blocks[i].definition = this.definition.blocks[j]
                        for(var k=0; k<this.page.blocks[i].definition.fields.length; k++){
                            var fieldDef = this.page.blocks[i].definition.fields[k]
                            if(fieldDef.handle in this.page.blocks[i].fields){

                                if (fieldDef.type == "list"){

                                    for(var n=0; n<this.page.blocks[i].fields[fieldDef.handle].length; n++){
                                        for(var l=0; l<fieldDef.fields.length; l++){
                                            if(!(fieldDef.fields[l].handle in this.page.blocks[i].fields[fieldDef.handle][n].fields)){
                                                this.page.blocks[i].fields[fieldDef.handle][n].fields[fieldDef.fields[l].handle] = {value: ''}
                                            }
                                        }
                                    }
                                }
                            }else{
                                if (fieldDef.type == "list"){
                                    this.page.blocks[i].fields[fieldDef.handle] = []
                                }else{
                                    this.page.blocks[i].fields[fieldDef.handle] = {value: ''}
                                }
                            }
                        }
                    }
                }
            }
            this.past_page = this.stringifyPage(this.page)
        }));


        this.$http.get('/articles/').then(data => {
            this.articles = data.data
        })
    },
    beforeRouteLeave (to, from, next) {
      if(!this.allChangesSaved(this.page)){
        this.modalUnsavedChangesOpen = true
        this.next = next
      }else{
        next()
      }
    }
}
</script>
